export const API_URL = 'api';
export const V = '1.0';
export const LK_URL = '/auth';
export const DIRECTIONS = ['Бразильского джиу-джитсу (БЖЖ)', 'Вольная борьба', 'Капоэйра'];
